module.exports = __webpack_public_path__ + "img/successful-checkmark.f6a7f50acfdfa8c8668b29baa43fd545.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/successful-checkmark.png
// module id = 378
// module chunks = 0